import React, { useState } from "react";
import { Lightbulb, X } from "lucide-react";

// A one-time inline hint. Remembers dismissal per-device via localStorage key.
export default function ContextualHint({ storageKey, children, testid = "contextual-hint" }) {
  const [seen, setSeen] = useState(() => localStorage.getItem(storageKey) === "1");
  if (seen) return null;
  const dismiss = () => { localStorage.setItem(storageKey, "1"); setSeen(true); };
  return (
    <div className="relative flex items-start gap-3 rounded-2xl border border-[#E6B34A]/30 bg-[#E6B34A]/[0.08] p-4 mb-4 fade-up" data-testid={testid}>
      <div className="w-8 h-8 rounded-full bg-[#E6B34A]/15 flex items-center justify-center shrink-0">
        <Lightbulb className="w-4 h-4 text-[#E6B34A]" />
      </div>
      <p className="text-sm text-zinc-200 leading-relaxed flex-1 pr-5">{children}</p>
      <button onClick={dismiss} data-testid={`${testid}-dismiss`} className="absolute top-3 right-3 text-zinc-400 hover:text-white transition-colors" title="Got it">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
